import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import { toast } from 'react-toastify';
import { useSetupPaymentMutation } from '../../slices/teachers/teacherApiPayment';

const TeacherSetupPayment = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const { teacherInfo } = useSelector((state) => state.authTeacher);

    const [setupPayment, { isLoading, error }] = useSetupPaymentMutation();

    useEffect(() => {
      if(!teacherInfo) {
          navigate('/teacherlogin')
      }
    }, [navigate, teacherInfo])

    useEffect(() => {
      if(teacherInfo?.isPaymentSetup) {
          navigate('/teacherrevenue')
      }
    }, [navigate, teacherInfo]);

    const setupPay = async (e) => {
        e.preventDefault()
        try {
            setLoading(true);
            const res = await setupPayment();
            window.location.href = res.data.url;
        } catch (error) {
            setLoading(false);
            toast.error('Unable to access payout settings. Try later.');  
        }
    }

  return (
    <div>
    <TeacherNavbar />
      <div className="main-content" id="panel">
      <TeacherHeader /><br /><br /><br /><br /><br />
        <div className="container-fluid mt--6">
          <div className="row">
            <div className="col-xl-8 offset-xl-2">  
              <div className="card-wrapper profileCard">
                <div className="card"> <br />
                    <h2 className="centerTitle tittleColor4 ">
                    <span className='tittleColor4'>
                        Set up you payouts account
                    </span>
                        </h2><br />
                    <div className="card-body">
                    <p className='text-info text-center'>
                        Setup your payouts account to start receiving payments from your subscribers <br /> 
                        Ask to Learn partners with stripe to transfer earnings to your bank account
                    </p><br /><br /><br />
                    {!loading ? (
                      <>                       
                        <Button type='submit' onClick={setupPay} variant='success' className=' btn btn-info btn-lg  rounded-pill bg-gradient-info setPay'>
                                Set Up Payment Account
                        </Button><br />
                      </>                    
                    ) : (                    
                      <Loader />
                    )}
                    <p className=" text-info text-center small tittleColor">
                    You will be redirected to stripe to complete onboarding process.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TeacherSetupPayment
